import type {
  ConversationLanguageCode,
  ConversationLanguageName,
} from 'lib-shared-languages';
import { conversationLanguages } from 'lib-shared-languages';
import { useMemo } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

export type SummaryLanguageValues = {
  /** The 2-letter language code used for the summary. Example: 'en', 'da' */
  readonly summaryLanguageCode?: ConversationLanguageCode;
  /** The full, human friendly, name of the language used for the summary */
  readonly summaryLanguage?: ConversationLanguageName;
};

export const useConversationSummaryLanguage = (): SummaryLanguageValues => {
  const { data } = useServerStorage('user');
  const { summaryLanguage } = data['agent_copilot'] || {};

  const summaryLanguageCode =
    summaryLanguage === 'detect' ? undefined : summaryLanguage;

  return useMemo(
    () => ({
      summaryLanguageCode,
      summaryLanguage:
        conversationLanguages.find(({ code }) => code === summaryLanguageCode)
          ?.name || undefined,
    }),
    [summaryLanguageCode],
  );
};
